export const FOTBOLL_PLAY_MODULE_CATEGORY_LABELS: Record<string, string> = {
  interview: 'Intervjuer',
  training: 'Träningar',
  match: 'Matcher',
  highlights: 'Sammandrag',
  pressConference: 'Presskonferenser',
  practiceMatches: 'Träningsmatcher',
  preseason: 'Försäsong',
  studioProgram: 'StudioProgram',
  reportage: 'Reportage',
  series: 'Serier',
  clubMeeting: 'Klubbmöten',
  archive: 'Arkiv',
  sustainability: 'Hållbarhet',
  education: 'Utbildning',
  other: 'Övrigt',
  all: 'Alla',
  'press conference': 'Presskonferenser',
  'studio program': 'Studio',
};

export const AVAILABLE_MODULE_CATEGORIES = Object.keys(FOTBOLL_PLAY_MODULE_CATEGORY_LABELS);

export function isCategoryModule(value: string): boolean {
  return value in FOTBOLL_PLAY_MODULE_CATEGORY_LABELS;
}
